import { type RefObject, useEffect, useState } from 'react'

/** Whether any of the element is on screen; true wherever the browser can't tell. */
export function useInView(ref: RefObject<Element | null>): boolean {
  const [inView, setInView] = useState(typeof IntersectionObserver === 'undefined')
  const [element, setElement] = useState<Element | null>(null)

  // Every render, so it picks up an element that mounts after the hook does (behind a loading state).
  // eslint-disable-next-line react-hooks/exhaustive-deps -- only sets state when the element changes
  useEffect(() => {
    if (ref.current !== element) setElement(ref.current)
  })

  useEffect(() => {
    if (!element || typeof IntersectionObserver === 'undefined') return
    const observer = new IntersectionObserver(([entry]) => setInView(entry.isIntersecting))
    observer.observe(element)
    return () => observer.disconnect()
  }, [element])

  return inView
}
